module.exports = __webpack_public_path__ + "images/f5d6949c7775f23d9def055ad2ac6633.webp";